// @ts-strict-ignore
import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLFormElement> {
  connect() {
    const calculatorValues = Array.from(this.element.querySelectorAll('[data-calculator-value]'))

    for (const calculatorValue of calculatorValues) {
      const format = calculatorValue.getAttribute('data-format')
      if (format === 'thousands') {
        calculatorValue.addEventListener('keyup', (e) => {
          const tempNumber = calculatorValue.value.replace(/,/gi, '')
          const commaSeparated = tempNumber.split(/(?=(?:\d{3})+$)/).join(',')
          calculatorValue.value = commaSeparated
        })
      }
    }
  }

  calculate() {
    const url = this.element.getAttribute('data-calculator-url')
    const urlParams = Array.from(this.element.querySelectorAll('[data-calculator-value]'))
      .map((calculatorValue) => {
        const format = calculatorValue.getAttribute('data-format')
        const value =
          format === 'thousands' ? calculatorValue.value.replace(/,/g, '') : calculatorValue.value
        return `${calculatorValue.name}=${value}`
      })
      .join('&')

    window.location.href = `${url}?${urlParams}`
  }
}
